import { initializeApp, type FirebaseApp } from 'firebase/app';

// Web app config from the Firebase console (Project settings → Your apps → Web app).
export const firebaseApp: FirebaseApp = initializeApp({
  apiKey: import.meta.env.FIREBASE_WEB_API_KEY,
  authDomain:
    import.meta.env.FIREBASE_WEB_AUTH_DOMAIN ||
    `${import.meta.env.FIREBASE_PROJECT_ID}.firebaseapp.com`,
  projectId: import.meta.env.FIREBASE_PROJECT_ID,
  appId: import.meta.env.FIREBASE_WEB_APP_ID,
  messagingSenderId: import.meta.env.FIREBASE_WEB_MESSAGING_SENDER_ID,
  measurementId: import.meta.env.FIREBASE_WEB_MEASUREMENT_ID,
});
